import { Component, OnInit } from '@angular/core';
import {DocumentService} from "../../../services/document";
import {ActivatedRoute, Router} from "@angular/router";
import {Document} from "../../../classes/document";
import {mergeMap} from "rxjs";
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-inspection-document-create',
  templateUrl: './inspection-document-create.component.html',
  styleUrls: ['./inspection-document-create.component.css']
})
export class InspectionDocumentCreateComponent implements OnInit {

  document = new Document();
  fileName = '';
  fileData = new FormData();
  inspectionDocumentUploadResult: boolean | undefined = undefined;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private documentService: DocumentService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.document.fk_id_inspection = parseInt(params.get('id')!);
    });
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileData.set('inspectionDocumentFile', file);
    }
  }

  onSubmit() {
    this.fileData.set('idInspection', (this.document.fk_id_inspection).toString());
    this.documentService.upload(this.fileData)
        .pipe(
            tap((fileInfo: any) => this.document.name = fileInfo.fileName),
            mergeMap(() => this.documentService.create(this.document))
        )
        .subscribe({
          next: () => {
            this.router.navigate(['/inspection/' + this.document.fk_id_inspection]);
          },
          error: e => {
            this.inspectionDocumentUploadResult = false;
            console.log(e);
          }
        });
  }

}
